import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const heading = css`
  display: flex;
  gap: 10px;
  > span {
    display: inline-flex;
    align-items: center;
  }
`;

export const buttonFAQ = css`
  text-decoration: none;
`;

export const cardWrapper = css`
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const buttonsWrapper = css`
  display: flex;
  margin-top: 20px;
  gap: 20px;
  & > * {
    width: 100%;
  }
`;

export const routingIcon = css`
  margin-right: 10px;
`;

export const savedRoutes = css`
  && {
    margin-left: 10px;
    color: ${colors.success.default};
    border-color: ${colors.success.default};
    &:hover {
      color: ${colors.success.hover};
      border-color: ${colors.success.hover};
    }
  }
`;

export const loadingCard = css`
  margin-top: 15px;
  width: 100%;
  height: 93px;
  border-radius: 5px;
  border: solid 1px ${colors.gray.light};
  background-color: ${colors.white};
`;

export const placeholder = css`
  margin: 40px 0 0;
`;
